export default __webpack_public_path__ + "static/media/FotoMauro.4a3d91f0.jfif";